import { Button, Grid, Paper, Stack } from "@mui/material";

import { Heading3 } from "../Typography/Heading/Heading";
import { Text1 } from "../Typography/Text/Text";
export const CommonMessage = ({ spacing,icon, heading, text,width,mode, onClick, btnName , widthIconcell }) => {
  return (
    <Paper
      variant={mode === "danger" ? "danger" : "LightBlue"}
      sx={{
        borderRadius: "4px",
        padding: "8px",
        width:width
      }}
    >
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        columnGap={mode === "danger" && "12px"}
        spacing={spacing?spacing:1.5}
      >
        <Grid item width={widthIconcell?widthIconcell:"12%"}>
          {icon}
        </Grid>
        <Grid item width={mode === "danger" ? "50%" : "88%"}>
          <Stack direction={"column"}>
            <Heading3 text={heading} />
            <Text1 text={text} />
          </Stack>
        </Grid>
        {mode === "danger" && (
          <Button onClick={onClick} variant="primaryRed">
            {btnName}
          </Button>
        )}
      </Grid>
    </Paper>
  );
};
